import React from "react";
import "../../styles/whatsApp.css";

const WhatsApp = () => {
  return (
    <div className="whatsapp">
      <a href="https://wa.me/923401248854" target="_blank">
        <img src="images/whatsapp-image.PNG" alt="pic" />
      </a>
    </div>
  );
};

export default WhatsApp;
